const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment-timezone');

/**
 * Defines the dynamic messaging component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('dynamicMessaging', ['Application', 'Authorization', 'DynamicMessages', 'CompanyIntegrations', function (Application, Authorization, DynamicMessages, CompanyIntegrations) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      contentType: '=',
      associatedContent: '=',
      messageId: '=',
      show: '=',
      refreshAndClose: '&',
      isMultiSession: '='
    },
    template: require('../../../templates/directives/messaging/dynamic-messaging.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.user = Authorization.getAuthToken().user;
      self.slackAvailable = false;

      CompanyIntegrations.status({}, function (data) {
        var companyIntegration = data || {};
        self.slackAvailable = companyIntegration.slack || false;
      }, function (error) {
        console.log('Error occured getting company integration ', error);
      });

      self.check = function() {
        if (!self.content.name) {
          Application.messaging.addMessage({type: 'error', duration: 5, text: 'Name is required'});
          return false;
        }
        if (!self.content.channels || !self.content.channels.length) {
          Application.messaging.addMessage({type: 'error', duration: 5, text: 'At least one channel must be selected'});
          return false;
        }
        for (var i = 0; i < self.content.channels.length; i++) {
          if (!self.content.messaging || !self.content.messaging[self.content.channels[i]] || !self.content.messaging[self.content.channels[i]].length) {
            Application.messaging.addMessage({type: 'error', duration: 5, text: 'Please include messaging for all selected channels.'});
            return false;
          }
        }
        if ($scope.contentType === 'Workshop' && self.content.messaging.slack && self.content.messaging.slack.length) {
          if (self.content.type === 'after_end') {
            self.content.messaging.slack.forEach(function(item) {
              if (item.name === 'include_template' && item.value === 'active') {
                item.value = 'inactive';
              }
            });
          }
        }
        return true;
      };

      self.info = {
        newMessage: true,
        loading: false,
        default: {
          name: '',
          scheduled: true,
          content_type: $scope.contentType,
          type: 'before_start',
          channels: ['in_app', 'slack', 'email'],
          messaging: {in_app: [], slack: [], email: []},
          scheduled_duration: 86400,
          options: [{name: 'audience', value: 'registered'}]
        },
        activeTab: 'schedule',
        cancel: function() {
          $scope.messageId = false;
          $scope.show = false;
        },
        save: function() {
          if (!self.check()) {
            return;
          }
          DynamicMessages.update({subresource: self.content._id, fields: 'company,user,scheduled,type,content_id,content_type,channels,messaging,scheduled_duration,options,name'}, self.content).$promise
          .then(function(message) {
            self.info.loading = true;
            $scope.refreshAndClose({text: 'Message successfully updated!'});
          }).catch(function(error) {
            console.log('error: ', error);
          });
        },
        create: function() {
          if (!self.check()) {
            return;
          }
          self.content.user = self.user._id;
          self.content.content_id = $scope.associatedContent._id || $scope.associatedContent.id;
          if (!self.slackAvailable) {
            for (var i = self.content.channels.length - 1; i > 0; i--) {
              if (self.content.channels[i] === 'slack') {
                self.content.channels.splice(i, 1);
              }
            }
          }

          DynamicMessages.create(self.content).$promise
          .then(function(message) {
            self.info.loading = true;
            $scope.refreshAndClose({text: 'Message successfully created!'});
          }).catch(function(error) {
            console.log('error: ', error);
          });
        }
      };

      if ($scope.contentType === 'Workshop') {
        self.info.default.messaging.slack.push({name: 'include_template', value: 'active'});
      }

      self.preview = {
        locationToggle: false,
        getBody: function(content) {
          var body = '';
          var opts = ['email', 'slack', 'in_app'];
          if (opts.indexOf(content) === -1 || !self.content || !self.content.messaging) {
            return body;
          }
          if (self.content.messaging[content] && self.content.messaging[content].length) {
            self.content.messaging[content].forEach(function(item) {
              if (item.name === 'body') {
                body = self.preview.parseTemplate(item.value, content);
              }
            });
          }

          return body;
        },
        escapeRegExp: function (str) {
          return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        },
        templateReplace: function (str, find, replace) {
          return str.replace(new RegExp(self.preview.escapeRegExp(find), 'g'), replace);
        },
        parseTemplate: function (template, content) {
          var variables = {};
          var stack = [];
          var newString = template.slice(0);
          var options = content === 'email' ? self.preview.options : self.preview.partialOptions;
          options.workshop_location = '<a href="https://continu.co">Continu Headquarters</a>';

          if (!self.preview.locationToggle) {
            options.workshop_location = 'Staples Center<br>1234 1st Street<br>Los Angeles, CA<br>';
          }

          for(var i = 0; i < template.length; i++) {
            if (template[i] === '{') {
              stack.push(i);
            }
            if (template[i] === '}' && stack.length) {
              variables[template.substring(stack.pop() + 1, i)] = true;
            }
          }

          for (var key in variables) {
            if (options[key]) {
              newString = self.preview.templateReplace(newString, '{' + key + '}', options[key]);
              continue;
            }
          }

          return newString;
        },
        partialOptions: {
          recipient_first_name: 'Jane',
          recipient_last_name: 'Doe',
          sender_first_name: 'John',
          sender_last_name: 'Smith',
          creator_first_name: 'Janice',
          creator_last_name: 'Jones',
          creator_full_name: 'Janice Jones',
          company: 'Great Company Inc',
          workshop_title: $scope.associatedContent && $scope.associatedContent.title || $scope.associatedContent.name || 'Intro Workshop',
          host_name: 'Alice Smith'
        },
        options: {
          recipient_first_name: 'Jane',
          recipient_last_name: 'Doe',
          sender_first_name: 'John',
          sender_last_name: 'Smith',
          creator_first_name: 'Janice',
          creator_last_name: 'Jones',
          creator_full_name: 'Janice Jones',
          company: 'Great Company Inc',
          workshop_title: $scope.associatedContent && $scope.associatedContent.title || $scope.associatedContent.name || 'Intro Workshop',
          workshop_start_date: moment().tz('America/Los_Angeles').format('MM/DD/YYYY'),
          workshop_start_time: moment().tz('America/Los_Angeles').format('h:mma z'),
          workshop_end_date: moment().add(2, 'hours').tz('America/Los_Angeles').format('DD/MM/YYYY'),
          workshop_end_time: moment().add(2, 'hours').tz('America/Los_Angeles').format('h:mma z'),
          host_name: 'Alice Smith'
        },
        slackIncludeTemplate: function() {
          if (!self.content || !self.content.messaging || !self.content.messaging.slack || !self.content.messaging.slack.length) {
            return false;
          }
          for (var i = 0; i < self.content.messaging.slack.length; i++) {
            if (self.content.messaging.slack[i].name === 'include_template' && self.content.messaging.slack[i].value === 'active') {
              return true;
            }
          }
          return false;
        }
      };

      self.hasChannel = function(name) {
        if (!self.content || !self.content.channels) {
          return false;
        }
        return self.content.channels.indexOf(name) !== -1;
      };

      self.initialize = function() {
        self.info.loading = true;
        if ($scope.messageId) {
          DynamicMessages.get({subresource: $scope.messageId, fields: 'company,user,scheduled,type,content_id,content_type,channels,messaging,scheduled_duration,options,name'}).$promise
          .then(function(message) {
            self.content = Object.assign({}, message);
            self.info.loading = false;  
            self.newMessage = false;
          });
          return;
        }
        self.content = Object.assign({}, self.info.default);
        self.info.loading = false;
      };

      self.initialize();

      $scope.$watch('show', function(newVal, oldVal) {
        if (newVal) {
          self.content = null;
          self.initialize();
        }
      });

    }],
    controllerAs: 'messaging'
  };
}]);